<!-- Google Maps API script -->
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCyzMRxB8Re27NYcuI8KDFCEucI0GwHLHA"></script>

<!-- App for the sytem message ribbon showed on CRUD -->
<app-system-message class="system-message"></app-system-message>

<!-- Container for the IOT component -->
<div [ngClass]="theme.getThemeClass()" class="container-fluid iotComponentDiv">
  <!-- Devices Location VIEW -->
  <div
    id="rowContent"

    [ngClass]="theme.getThemeClass()"
  >
    <section id="columList" class="hide-small-screen columList table-big-sreen">
      <article [ngClass]="theme.getThemeClass()" class="table-container">
        <section
          [ngClass]="theme.getThemeClass()"
          class="devices-location-section"
        >
          <ul class="device-location-list">
            <h3 class="device-location-list-header">{{ "iotNavButtonDevices" | translate}}</h3>
            @for (device of devicesLocationArray; track $index) {
            <li class="device-list-item" (click)="zoomToDevice(device)">
              {{ device.thingName }}
            </li>
            }
          </ul>
          <div #mapContainer id="mapAllDevices" class="mapDesktop"></div>
        </section>
      </article>
    </section>
  </div>
</div>
